const types = {
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SET_DOCUMENTO: 'SET_DOCUMENTO',
  SET_PRESENTE_CAIXA_POSTAL: 'SET_PRESENTE_CAIXA_POSTAL',
  SET_RAIZ_PRESENTE_CAIXA_POSTAL: 'SET_RAIZ_PRESENTE_CAIXA_POSTAL',
  SET_EMAIL_INTERESSADO: 'SET_EMAIL_INTERESSADO',
  SET_URL_CONSOLIDACAO: 'SET_URL_CONSOLIDACAO',
  SET_LISTA_CONSOLIDACOES: 'SET_LISTA_CONSOLIDACOES',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
}

export default types
